"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListaDeSelecao = void 0;
var estiloListaDeSelecao = require("./lista-de-selecao.module.scss");
var react_1 = __importStar(require("react"));
var TextAreaLista_1 = require("../TextAreaLista/TextAreaLista");
var Botao_1 = require("../../Botao/Botao");
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var ListaDeSelecao = function (_a) {
    var arraySelecao = _a.arrayParaSelecao, arraySelecionados = _a.arraySelecionados, _b = _a.config, _c = _b.regraEstado, regraEstado = _c === void 0 ? function () { return false; } : _c, _d = _b.selecaoExcludente, selecaoExcludente = _d === void 0 ? true : _d, listasOrdenadas = _b.listasOrdenadas, _e = _b.regraTitulo, regraTitulo = _e === void 0 ? function (item) { return JSON.stringify(item); } : _e, tituloSelecao = _b.tituloSelecao, tituloSelecionados = _b.tituloSelecionados, styleSelecao = _b.styleSelecao, styleSelecionados = _b.styleSelecionados, onSelecaoChange = _a.onClickSelecao, onSelecionadosChange = _a.onClickSelecionados, onChange = _a.onChange, onChangeSelecao = _a.onChangeSelecao, onDeleteSelecao = _a.onDeleteSelecao, onDeleteSelecionados = _a.onDeleteSelecionados;
    function converterParaListaDeSelecaoInput(lista, regraTitulo, regraEstado) {
        return lista.map(function (objeto) { return ({
            objeto: objeto,
            titulo: regraTitulo(objeto),
            estado: regraEstado ? regraEstado(objeto) : false,
        }); });
    }
    var arraySelecaoConvertido = converterParaListaDeSelecaoInput(arraySelecao, regraTitulo, regraEstado);
    var arraySelecionadosConvertido = converterParaListaDeSelecaoInput(arraySelecionados, regraTitulo, regraEstado);
    var _f = (0, react_1.useState)(arraySelecaoConvertido), listaDeSelecao = _f[0], setListaDeSelecao = _f[1];
    var _g = (0, react_1.useState)(arraySelecionadosConvertido), listaDeSelecionados = _g[0], setListaDeSelecionados = _g[1];
    var adicionarTodos = function () {
        var itensSelecionados = listaDeSelecao.map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        if (listasOrdenadas) {
            setListaDeSelecionados(function (prev) {
                var _a;
                return (_a = __spreadArray(__spreadArray([], prev, true), itensSelecionados, true).sort(function (a, b) {
                    return a.titulo.localeCompare(b.titulo);
                })) !== null && _a !== void 0 ? _a : [];
            });
        }
        else {
            setListaDeSelecionados(function (prev) { return __spreadArray(__spreadArray([], prev, true), itensSelecionados, true); });
        }
        if (selecaoExcludente) {
            setListaDeSelecao([]);
            onChangeSelecao && onChangeSelecao([]);
        }
        var listaSelecionadosSemUndefined = listaDeSelecionados
            .map(function (item) { return item.objeto; })
            .filter(function (objeto) { return objeto !== undefined; });
        var itensSelecionadosSemUndefined = itensSelecionados
            .map(function (item) { return item.objeto; })
            .filter(function (objeto) { return objeto !== undefined; });
        onChange(__spreadArray(__spreadArray([], listaSelecionadosSemUndefined, true), itensSelecionadosSemUndefined, true));
    };
    var adicionarItens = function () {
        var itensParaAdicionar = listaDeSelecao.filter(function (item) { return item.estado === true; });
        var itensSelecionados = itensParaAdicionar.map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        if (listasOrdenadas) {
            setListaDeSelecionados(function (prev) {
                return __spreadArray(__spreadArray([], prev, true), itensSelecionados, true).sort(function (a, b) {
                    return a.titulo.localeCompare(b.titulo);
                });
            });
        }
        else {
            setListaDeSelecionados(function (prev) { return __spreadArray(__spreadArray([], prev, true), itensSelecionados, true); });
        }
        if (selecaoExcludente) {
            var listaDeSelecaoAtualizada = listaDeSelecao.filter(function (item) { return !item.estado; });
            setListaDeSelecao(listaDeSelecaoAtualizada);
            onChangeSelecao && onChangeSelecao(listaDeSelecaoAtualizada.map(function (item) { return item.objeto; })
                .filter(function (objeto) { return objeto !== undefined; }));
        }
        else {
            var listaDeSelecaoMantida = listaDeSelecao.map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
            setListaDeSelecao(listaDeSelecaoMantida);
            onChangeSelecao && onChangeSelecao(listaDeSelecaoMantida.map(function (item) { return item.objeto; })
                .filter(function (objeto) { return objeto !== undefined; }));
        }
        var listaSelecionadosSemUndefined = listaDeSelecionados
            .map(function (item) { return item.objeto; })
            .filter(function (objeto) { return objeto !== undefined; });
        var itensSelecionadosSemUndefined = itensSelecionados
            .map(function (item) { return item.objeto; })
            .filter(function (objeto) { return objeto !== undefined; });
        onChange(__spreadArray(__spreadArray([], listaSelecionadosSemUndefined, true), itensSelecionadosSemUndefined, true));
    };
    var removerItens = function () {
        var _a;
        var itensParaRemover = listaDeSelecionados.filter(function (item) { return item.estado === true; });
        var listaDeSelecionadosAtualizada = (_a = listaDeSelecionados.filter(function (item) { return !item.estado; })) !== null && _a !== void 0 ? _a : [];
        var itensAtualizados = itensParaRemover.map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        if (selecaoExcludente) {
            if (listasOrdenadas) {
                setListaDeSelecionados(listaDeSelecionadosAtualizada.sort(function (a, b) { return a.titulo.localeCompare(b.titulo); }));
                setListaDeSelecao(function (prev) {
                    return __spreadArray(__spreadArray([], prev, true), itensAtualizados, true).sort(function (a, b) { return a.titulo.localeCompare(b.titulo); });
                });
            }
            else {
                setListaDeSelecionados(listaDeSelecionadosAtualizada);
                setListaDeSelecao(function (prev) { return __spreadArray(__spreadArray([], prev, true), itensAtualizados, true); });
            }
        }
        else {
            setListaDeSelecionados(listaDeSelecionadosAtualizada);
        }
        var listaSelecionadosSemUndefined = listaDeSelecionadosAtualizada
            .map(function (item) { return item.objeto; })
            .filter(function (objeto) { return objeto !== undefined; });
        onChange(listaSelecionadosSemUndefined);
        if (selecaoExcludente) {
            var listaObjetosAtualizada = __spreadArray(__spreadArray([], listaDeSelecao, true), itensAtualizados, true).map(function (item) { return item.objeto; })
                .filter(function (objeto) { return objeto !== undefined; });
            onChangeSelecao && onChangeSelecao(listaObjetosAtualizada);
        }
    };
    var removerTodos = function () {
        var itensAtualizados = listaDeSelecionados.map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        if (selecaoExcludente) {
            if (listasOrdenadas) {
                setListaDeSelecao(function (prev) {
                    return __spreadArray(__spreadArray([], prev, true), itensAtualizados, true).sort(function (a, b) { return a.titulo.localeCompare(b.titulo); });
                });
            }
            else {
                setListaDeSelecao(function (prev) { return __spreadArray(__spreadArray([], prev, true), itensAtualizados, true); });
            }
            var listaObjetosAtualizada = __spreadArray(__spreadArray([], listaDeSelecao, true), itensAtualizados, true).map(function (item) { return item.objeto; })
                .filter(function (objeto) { return objeto !== undefined; });
            onChangeSelecao && onChangeSelecao(listaObjetosAtualizada);
        }
        setListaDeSelecionados([]);
        onChange([]);
    };
    var handleClick = function (item, lista) {
        if (lista === "selecao") {
            var novaListaDeSelecao = listaDeSelecao.map(function (i) {
                return i === item ? __assign(__assign({}, i), { estado: !i.estado }) : i;
            });
            setListaDeSelecao(novaListaDeSelecao);
            onSelecaoChange && onSelecaoChange(novaListaDeSelecao);
        }
        else {
            var novaListaDeSelecao = listaDeSelecionados.map(function (i) {
                return i === item ? __assign(__assign({}, i), { estado: !i.estado }) : i;
            });
            setListaDeSelecionados(novaListaDeSelecao);
            onSelecionadosChange && onSelecionadosChange(novaListaDeSelecao);
        }
    };
    var renderBotaoMenor = function (icon, onClick) {
        return (react_1.default.createElement("li", null,
            react_1.default.createElement(Botao_1.Botao, { tamanho: "small", exibirBotaoArrendondado: true, tipo: "tipoIconRound", estilo: "outlined", onClick: onClick },
                react_1.default.createElement(Icone_1.Icone, { nome: icon, cor: Cores_1.Cores.CoresIdentidadeMU.azulMu, largura: "1.5rem", altura: "1.5rem" }))));
    };
    var renderBotaoMaior = function (icon, onClick) {
        return (react_1.default.createElement("li", null,
            react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, tipo: "tipoIconRound", tamanho: "large", onClick: onClick },
                react_1.default.createElement(Icone_1.Icone, { nome: icon, cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, largura: "2rem", altura: "2rem" }))));
    };
    var renderControles = function () {
        return (react_1.default.createElement("ul", { className: estiloListaDeSelecao.controles },
            renderBotaoMenor("keyboard_double_arrow_right", adicionarTodos),
            renderBotaoMaior("arrow_forward", adicionarItens),
            renderBotaoMaior("arrow_back", removerItens),
            renderBotaoMenor("keyboard_double_arrow_left", removerTodos)));
    };
    (0, react_1.useEffect)(function () { }, [adicionarTodos]);
    (0, react_1.useEffect)(function () {
        var _a;
        setListaDeSelecao((_a = converterParaListaDeSelecaoInput(arraySelecao, regraTitulo, regraEstado)) !== null && _a !== void 0 ? _a : []);
    }, [arraySelecao]);
    (0, react_1.useEffect)(function () {
        var _a;
        setListaDeSelecionados((_a = converterParaListaDeSelecaoInput(arraySelecionados, regraTitulo, regraEstado)) !== null && _a !== void 0 ? _a : []);
    }, [arraySelecionados]);
    return (react_1.default.createElement("div", { className: estiloListaDeSelecao.container },
        react_1.default.createElement("div", { className: estiloListaDeSelecao.listaEsquerda },
            react_1.default.createElement(TextAreaLista_1.TextAreaLista, { id: "listaDeSelecao", titulo: tituloSelecao !== null && tituloSelecao !== void 0 ? tituloSelecao : "Seleção :", opcoes: listaDeSelecao, style: styleSelecao !== null && styleSelecao !== void 0 ? styleSelecao : {
                    minWidth: '100%',
                    width: '100%',
                    maxWidth: '20rem',
                    minHeight: '10rem',
                    maxHeight: '10rem',
                }, onDeleteBtnClick: onDeleteSelecao ? function () { return onDeleteSelecao(); } : undefined, onClickItem: function (item) { return handleClick(item, "selecao"); } })),
        react_1.default.createElement("div", { className: estiloListaDeSelecao.controles }, renderControles()),
        react_1.default.createElement("div", { className: estiloListaDeSelecao.listaDireita },
            react_1.default.createElement(TextAreaLista_1.TextAreaLista, { id: "listaDeSelecionados", titulo: tituloSelecionados !== null && tituloSelecionados !== void 0 ? tituloSelecionados : "Selecionados :", opcoes: listaDeSelecionados, style: styleSelecionados !== null && styleSelecionados !== void 0 ? styleSelecionados : {
                    minWidth: '100%',
                    width: '100%',
                    maxWidth: '20rem',
                    minHeight: '10rem',
                    maxHeight: '10rem',
                }, onDeleteBtnClick: onDeleteSelecionados ? function () { return onDeleteSelecionados(); } : undefined, onClickItem: function (item) { return handleClick(item, "selecionados"); } }))));
};
exports.ListaDeSelecao = ListaDeSelecao;
